import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from "react-intl";

import Badge from "components/Badge";

import {blue700, green700, orange700, red700} from "assets/jss/main";

import {LineItemStatus} from "utils/LineItemStatus";
import {countByStatuses} from "views/oms/OrderList/utils/countByStatuses";
import {sortByStatusFlow} from "views/oms/OrderList/utils/sortByStatusFlow";

MobileLineItemStatusesBadgeList.propTypes = {
    lineItems: PropTypes.arrayOf(PropTypes.shape({
        status: PropTypes.string
    })).isRequired
};

const statusColorMap = {
    [LineItemStatus.PENDING]: {theme: 'yellow'},
    [LineItemStatus.RESERVED]: {theme: 'purple'},
    [LineItemStatus.TO_SHIP]: {theme: 'default', color: blue700},
    [LineItemStatus.CONFIRMED]: {theme: 'online', color: green700},
    [LineItemStatus.CANCELED]: {theme: 'error', color: red700},
    [LineItemStatus.RETURNED]: {theme: 'warning', color: orange700},
    [LineItemStatus.RETURNING_RUNNER]: {theme: 'warning', color: orange700},
    [LineItemStatus.RETURNING_RETAILER]: {theme: 'warning', color: orange700},
    [LineItemStatus.UNAVAILABLE]: {theme: 'error', color: red700},
};

function MobileLineItemStatusesBadgeList({lineItems}) {
    const statusCounts = countByStatuses(lineItems);

    return (
        <div style={{
            display: 'flex',
            flexWrap: 'wrap',
            gap: '4px',
        }}>
            {Object.entries(statusCounts).sort(sortByStatusFlow).map(([status, count]) => (
                <Badge
                    key={status}
                    size={'large'}
                    border
                    color={statusColorMap[status].theme}
                    labelColor={statusColorMap[status].color ?? statusColorMap[status].theme}
                    isBold={false}
                    labelSize={14}
                >
                    {count}&nbsp;
                    <span style={{textTransform: 'lowercase'}}>
                        <FormattedMessage id={`oms.order.list.lineItemStatus.${status}`} values={{count}} />
                    </span>
                </Badge>
            ))}
        </div>
    );
}

export default MobileLineItemStatusesBadgeList;
